// IMG
import { LogoCorreios } from '@assets/';
// Garden
import { Field, Select } from '@zendeskgarden/react-forms';
// Components
import { Accordion, Button, TextLoading } from '@components/';
// Hooks
import { useHome } from './useHome';
import React from 'react';

export function Home() {
  const {
    brandOptions,
    brandId,
    handleChange,
    handleSubmit,
    loading,
    postage,
    codObjeto,
    incidentPostages,
  } = useHome();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="w-full max-w-lg">
          <TextLoading texts={['Carregando...', 'Buscando dados do ticket...']} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-40px)]">
      <img
        src={LogoCorreios}
        alt="Logo"
        className={`w-[107px] h-[22px]  ${codObjeto ? 'mt-4' : 'mt-auto'}`}
      />

      {postage && (
        <div className="mt-4 w-full">
          {postage.objetos.map((item) => {
            console.log(item);
            return (
              <Accordion
                items={{
                  title: 'Dados da postagem',
                  content: (
                    <React.Fragment>
                      <div className="grid grid-cols-2 items-center mb-2">
                        <p className="text-[#87929D]">Código de rastreio</p>
                        <div>
                          <p className="bg-[#E9EBED] inline-block py-[2px] px-[8px] text-center truncate">
                            {item.codObjeto}
                          </p>
                        </div>
                      </div>
                      {postage.ehColeta && (
                        <div className="grid grid-cols-2 items-center mb-2">
                          <p className="text-[#87929D]">Código solicitação</p>
                          <div>
                            <p className="bg-[#E9EBED] inline-block py-[2px] px-[8px] text-center truncate">
                              {item.nuColeta}
                            </p>
                          </div>
                        </div>
                      )}
                      {postage.ehColeta && (
                        <div className="grid grid-cols-2 items-center mb-2">
                          <p className="text-[#87929D]">Prazo</p>
                          <div>
                            <p className="bg-[#E9EBED] inline-block py-[2px] px-[8px] text-center truncate">
                              {item.prazo}
                            </p>
                          </div>
                        </div>
                      )}
                      {postage.ehColeta && (
                        <div className="grid grid-cols-2 items-center mb-2">
                          <p className="text-[#87929D]">Data da solicitação</p>
                          <div>
                            <p className="bg-[#E9EBED] inline-block py-[2px] px-[8px] text-center truncate">
                              {item.dataSolicitacao}
                            </p>
                          </div>
                        </div>
                      )}
                      {!postage.ehColeta && item?.tipoPostal?.categoria && (
                        <div className="grid grid-cols-2 items-center mb-2">
                          <p className="text-[#87929D]">Tipo postal</p>
                          <div>
                            <p className="bg-[#E9EBED] inline-block py-[2px] px-[8px] text-center truncate">
                              {item.tipoPostal.categoria}
                            </p>
                          </div>
                        </div>
                      )}
                      {item?.eventos?.length > 0 && (
                        <React.Fragment>
                          {!postage.ehColeta && (
                            <div className="grid grid-cols-2 items-center mb-2">
                              <p className="text-[#87929D]">Descrição</p>
                              <div>
                                <p className="font-normal py-[2px] px-[8px]">
                                  {item?.eventos[0]?.descricao}
                                </p>
                              </div>
                            </div>
                          )}
                          {!postage.ehColeta && (
                            <div className="grid grid-cols-2 items-center mb-2">
                              <p className="text-[#87929D]">Status</p>
                              <div>
                                <p className="font-normal py-[2px] px-[8px]">
                                  {item?.eventos[0]?.detalhe}
                                </p>
                              </div>
                            </div>
                          )}{' '}
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  ),
                }}
              />
            );
          })}
        </div>
      )}
      {incidentPostages && (
        <div className="mt-4 w-full">
          {incidentPostages.map((a) => {
            return a.data.objetos.map((item) => {
              return (
                <Accordion
                  key={item.codObjeto}
                  items={{
                    title: 'Dados da postagem',
                    content: (
                      <React.Fragment>
                        <div className="grid grid-cols-2 items-center mb-2">
                          <p className="text-[#87929D]">Código de rastreio</p>
                          <div>
                            <p className="bg-[#E9EBED] inline-block py-[2px] px-[8px] text-center truncate">
                              {item.codObjeto}
                            </p>
                          </div>
                        </div>
                        <div className="grid grid-cols-2 items-center mb-2">
                          <p className="text-[#87929D]">Tipo postal</p>
                          <div>
                            <p className="bg-[#E9EBED] inline-block py-[2px] px-[8px] text-center truncate">
                              {item.tipoPostal.categoria}
                            </p>
                          </div>
                        </div>
                        {item.eventos[0] && (
                          <React.Fragment>
                            <div className="grid grid-cols-2 items-center mb-2">
                              <p className="text-[#87929D]">Descrição</p>
                              <div>
                                <p className="font-normal py-[2px] px-[8px]">
                                  {item.eventos[0].descricao}
                                </p>
                              </div>
                            </div>
                            <div className="grid grid-cols-2 items-center mb-2">
                              <p className="text-[#87929D]">Status</p>
                              <div>
                                <p className="font-normal py-[2px] px-[8px]">
                                  {item.eventos[0].detalhe}
                                </p>
                              </div>
                            </div>
                            <div className="grid grid-cols-2 items-center mb-2">
                              <p className="text-[#87929D]">Ticket Incidente</p>
                              <div>
                                <a
                                  href={
                                    'https://atendimento-britania.zendesk.com/agent/tickets/' +
                                    a.ticket
                                  }
                                  target="_blank"
                                  className="font-normal py-[2px] px-[8px]"
                                >
                                  {a.ticket}
                                </a>
                              </div>
                            </div>{' '}
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    ),
                  }}
                />
              );
            });
          })}
        </div>
      )}

      <form onSubmit={handleSubmit} className="mt-auto border-t border-t-[#D8DCDE] w-full p-4">
        <Field className="flex flex-col gap-4">
          <Select value={brandId ?? ''} onChange={handleChange} className="outline-none">
            <option value="">Selecione...</option>
            {brandOptions.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label}
              </option>
            ))}
          </Select>

          <Button className="w-full" disabled={!brandId || loading} type="submit" isPrimary>
            Gerar postagem
          </Button>
        </Field>
      </form>
    </div>
  );
}
